import type { Task } from "@estelle/domain";

import { Badge } from "@/components/ui/badge";

/**
 * The mark that tells a subtask from any other task in a list, the board and
 * My Tasks (#666), so nobody opens one without knowing it belongs to a parent.
 * Names the parent's reference when the parent is among `all` (the lists fetch
 * every task); otherwise just "Subtask", for a parent that has been deleted.
 * Nothing for a top-level task.
 */
export function SubtaskBadge({
  task,
  all,
}: {
  task: Task;
  all: readonly Task[];
}) {
  if (task.parentTaskId === null) return null;
  const parent = all.find((candidate) => candidate.id === task.parentTaskId);
  return (
    <Badge
      variant="outline"
      className="shrink-0 font-normal"
      title={
        parent ? `Subtask of ${parent.reference} · ${parent.title}` : undefined
      }
    >
      {parent ? `Subtask of ${parent.reference}` : "Subtask"}
    </Badge>
  );
}
